<template>
    <div>
        <div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-search"></i><span>档案检索</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<el-divider></el-divider>

        <div class="container" style="color: #606266;">
            <div style="display: flex;">
                <div style="line-height: 32px;">档管家为您找到相关结果约{{ fuzzySearchForm.count }}个。</div>
                <div style="margin-left: 60px;">
                    <el-button plain style="width: 100px;" @click="returnPrevPageFun()">返回检索</el-button>
                </div>
            </div>
            <div style="margin-top: 15px;overflow-y: auto;height: 700px;">
                <!-- 模糊查询 -->
                <div v-show="searchType == 1">
                    <div v-for="(searchObj, index) in fuzzySearchForm.fuzzySearchData" :key="index">
                        <div style="display: flex;margin-bottom: 20px;">
                            <!-- 记账凭证、原始凭证、组、册-->
                            <div v-if="searchObj.id.search('file-') != -1" style="display: flex;">
                                <div v-for="(imgObj, index) in voucherTypeImgList" :key="index">
                                    <div v-if="searchObj.voucherType == imgObj.code">
                                        <div style="width: 50px;height: 50px;">
                                            <img :src="require('../../../assets/img/' + imgObj.name + '.png')">
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div style="display: flex;line-height: 37px;height: 37px;">
                                    <div style="font-weight: bold;font-size: 15px;color: #409EFF;padding-right: 20px;width: 55%;">
                                        <el-link type="primary"  :underline="true" style="font-weight: bold;font-size: 15px;color: #409EFF;line-height: 24px;" @click="viewVoucherDetailClickFun(searchObj.voucherType, searchObj.id.substr(5))">{{ searchObj.voucherNo }}</el-link>
                                        （凭证号）
                                    </div>
                                    <div v-for="(imgObj, index) in fileStatusImgList" :key="index">
                                        <img v-if="searchObj.status == imgObj.code" :src="require('../../../assets/img/' + imgObj.name + '.png')">
                                    </div>
                                    </div>
                                    <div style="display: flex;font-size: 13px;line-height: 30px;">
                                        <div style="margin-right: 20px;">上传人：{{ searchObj.operator }}</div>
                                        <div style="margin-right: 20px;">最近操作时间：{{ searchObj.operateTime }}</div>
                                        <div>所属实体：{{ searchObj.stmc}}</div>
                                    </div>
                                    <div style="width:700px;height:auto" v-html="searchObj.queryWord"></div>
                                </div>
                            </div>
                            <div v-if="searchObj.id.search('group-') != -1">
                                <div style="display: flex;line-height: 37px;height: 37px;">
                                    <div style="font-weight: bold;font-size: 15px;color: #409EFF;padding-right: 20px;width: 80%;">
                                        <el-link type="primary"  :underline="true" style="font-weight: bold;font-size: 15px;color: #409EFF;line-height: 24px;" @click="viewGroupDetailClickFun(searchObj.id.substr(6))">{{ searchObj.groupHm }}</el-link>
                                        （组号）
                                    </div>
                                    <img  :src="require('../../../assets/img/archives-yfz.png')">
                                </div>
                                <div style="display: flex;font-size: 13px;line-height: 30px;">
                                    <div style="margin-right: 20px;">操作人：{{ searchObj.operator }}</div>
                                    <div style="margin-right: 20px;">最近操作时间：{{ searchObj.operateTime }}</div>
                                    <div>所属实体：{{ searchObj.stmc}}</div>
                                </div>
                            </div>
                            <div v-if="searchObj.id.search('book-') != -1">
                               <div style="display: flex;line-height: 37px;height: 37px;">
                                    <div style="font-weight: bold;font-size: 15px;color: #409EFF;padding-right: 20px;width: 55%;">
                                        <el-link type="primary"  :underline="true" style="font-weight: bold;font-size: 15px;color: #409EFF;line-height: 24px;" @click="viewBookDetailClickFun(searchObj.id.substr(5))">{{ searchObj.bookHm }}</el-link>
                                        （册号）
                                    </div>
                                    <img v-show="searchObj.status==='1'" :src="require('../../../assets/img/archives-ycc.png')">
                                    <img v-show="searchObj.status==='0'" :src="require('../../../assets/img/archives-ccz.png')">
                                </div>
                                <div style="display: flex;font-size: 13px;line-height: 30px;">
                                    <div style="margin-right: 20px;">操作人：{{ searchObj.operator }}</div>
                                    <div style="margin-right: 20px;">成册时间：{{ searchObj.operateTime }}</div>
                                    <div>所属实体：{{ searchObj.stmc}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 文件 -->
                <div v-show="searchType == 2">
                    <div v-for="(searchObj, index) in fuzzySearchForm.fuzzySearchData" :key="index">
                        <div style="display: flex;margin-bottom: 20px;">
                            <!-- 记账凭证、原始凭证 -->
                            <div v-for="(imgObj, index) in voucherTypeImgList" :key="index">
                                <div v-if="searchObj.type == imgObj.code">
                                    <div style="width: 50px;height: 50px;">
                                        <img :src="require('../../../assets/img/' + imgObj.name + '.png')">
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style="display: flex;line-height: 37px;height: 37px;">
                                    <div style="font-weight: bold;font-size: 15px;color: #409EFF;padding-right: 20px;width: 55%;">
                                        <el-link type="primary"  :underline="true" style="font-weight: bold;font-size: 15px;color: #409EFF;line-height: 24px;" @click="viewVoucherDetailClickFun(searchObj.type, searchObj.id)">{{ searchObj.number }}</el-link>
                                        （凭证号）
                                    </div>
                                    <div v-for="(imgObj, index) in fileStatusImgList" :key="index">
                                        <img v-if="searchObj.status == imgObj.code" :src="require('../../../assets/img/' + imgObj.name + '.png')">
                                    </div>
                                </div>
                                <div style="display: flex;font-size: 13px;line-height: 30px;">
                                    <div style="margin-right: 20px;">上传人：{{ searchObj.operator }}</div>
                                    <div style="margin-right: 20px;">最近操作时间：{{ searchObj.operateTime }}</div>
                                    <div>所属实体：{{ searchObj.companyName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 组 -->
                <div v-if="searchType == 3">
                    <div v-for="(searchObj, index) in fuzzySearchForm.fuzzySearchData" :key="index">
                        <div style="display: flex;margin-bottom: 20px;">
                            <!-- 组 -->
                            <div>
                                <div style="display: flex;line-height: 37px;height: 37px;">
                                    <div style="font-weight: bold;font-size: 15px;color: #409EFF;padding-right: 20px;width: 55%;">
                                        <el-link type="primary"  :underline="true" style="font-weight: bold;font-size: 15px;color: #409EFF;line-height: 24px;" @click="viewGroupDetailClickFun(searchObj.id)">{{ searchObj.number }}</el-link>
                                        （组号）
                                    </div>
                                    <!-- 固定图标为已分组 -->
                                    <img  :src="require('../../../assets/img/archives-yfz.png')">
                                </div>
                                <div style="display: flex;font-size: 13px;line-height: 30px;">
                                    <div style="margin-right: 20px;">操作人：{{ searchObj.operator }}</div>
                                    <div style="margin-right: 20px;">最近操作时间：{{ searchObj.operateTime }}</div>
                                    <div>所属实体：{{ searchObj.companyName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 册 -->
                <div v-if="searchType == 4">
                    <div v-for="(searchObj, index) in fuzzySearchForm.fuzzySearchData" :key="index">
                        <div style="display: flex;margin-bottom: 20px;">
                            <!-- 册 -->
                            <div>
                                <div style="display: flex;line-height: 37px;height: 37px;">
                                    <div style="font-weight: bold;font-size: 15px;color: #409EFF;padding-right: 20px;width: 55%;">
                                        <el-link type="primary"  :underline="true" style="font-weight: bold;font-size: 15px;color: #409EFF;line-height: 24px;" @click="viewBookDetailClickFun(searchObj.id)">{{ searchObj.number }}</el-link>
                                        （册号）
                                    </div>
                                    <img v-show="searchObj.status==='1'" :src="require('../../../assets/img/archives-ycc.png')">
                                    <img v-show="searchObj.status==='0'" :src="require('../../../assets/img/archives-ccz.png')">
                                </div>
                                <div style="display: flex;font-size: 13px;line-height: 30px;">
                                    <div style="margin-right: 20px;">操作人：{{ searchObj.operator }}</div>
                                    <div style="margin-right: 20px;">最近操作时间：{{ searchObj.operateTime }}</div>
                                    <div>所属实体：{{ searchObj.companyName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div style="display: flex;margin-bottom: 20px;">
                    <div>
                        <div style="width: 50px;height: 50px;">
                            <img src="../../../assets/img/archives-fz.png">
                        </div>
                    </div>
                    <div>
                        <div style="height: 30px;">
                            <span style="font-weight: bold;font-size: 15px;color: #409EFF;">组号G20200917001</span>
                        </div>
                        <div style="display: flex;font-size: 13px;line-height: 37px;height: 37px;">
                            <div style="margin-right: 20px;">操作人：李德桃</div>
                            <div style="margin-right: 20px;">最近操作时间：2020年8月19日</div>
                            <div style="margin-right: 10px;">当前状态：</div>
                            <img src="../../../assets/img/archives-yfz.png">
                        </div>
                        <div style="font-size: 13px;line-height: 30px;">······明细信息······</div>
                    </div>
                </div>
                <div style="display: flex;">
                    <div>
                        <div style="width: 50px;height: 50px;">
                            <img src="../../../assets/img/archives-cc.png">
                        </div>
                    </div>
                    <div>
                        <div style="height: 30px;">
                            <span style="font-weight: bold;font-size: 15px;color: #409EFF;">目录名称ML20200819001</span>
                        </div>
                        <div style="display: flex;font-size: 13px;line-height: 37px;height: 37px;">
                            <div style="margin-right: 20px;">装册人：李桃德</div>
                            <div style="margin-right: 20px;">装册日期：2020年06月04日</div>
                            <div style="margin-right: 20px;">最近操作时间：2020年9月18日</div>
                            <div style="margin-right: 10px;">当前状态：</div>
                            <img src="../../../assets/img/archives-ycc.png">
                        </div>
                        <div style="display: flex;font-size: 13px;line-height: 37px;height: 37px;">
                            <div style="margin-right: 20px;">册号：12345678</div>
                        </div>
                        <div style="font-size: 13px;line-height: 30px;">······明细信息······</div>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- 查看文件明细 -->
        <custom ref="voucher" v-bind:voucher="voucher"></custom>
    </div>
</template>

<script>
    import https from '../../../../https.js';
    import voucher from '../common/custom.vue';
    export default {
        data() {
            return {
                fuzzySearchForm: {
                    count: 0,
                    fuzzySearchData: []
                },
                voucherTypeImgList: JSON.parse(JSON.stringify(this.accountingVoucherTypeList)).concat(JSON.parse(JSON.stringify(this.originalvoucherTypeList))),
                fileStatusImgList: JSON.parse(JSON.stringify(this.fileStatusList)),
                voucher: {
                    vftype: '',	//	凭证类型：1：记账凭证 2：原始凭证
                    vid: ''	//	凭证ID
                },
                searchType: null //检索方式,1模糊、2文件、3组、4册子
            }
        },
        components: {
            voucher
        },
        created: function() {
            let fuzzySearchData = this.$route.params.findFileData;
            this.searchType = this.$route.params.searchType;
            console.log(fuzzySearchData)
            if(fuzzySearchData) {
                this.fuzzySearchForm.count = fuzzySearchData.length;
            }
            this.fuzzySearchForm.fuzzySearchData = fuzzySearchData;
        },
        methods: {
            viewVoucherDetailClickFun(vftype, voucherId) {   //  查看凭证明细
                this.voucher.vftype = vftype == "0" ? "1" :  "2";	// 凭证类型
                this.voucher.vid = voucherId;
                this.$refs.voucher.viewVoucherDetailsClickFun();
            },
            viewGroupDetailClickFun(groupId){
                this.$refs.voucher.viewGroupDetailsClickFun(groupId);
            },
            viewBookDetailClickFun(bookId){
                this.$refs.voucher.viewVolumeDetailsClickFun(bookId);
            },
            returnPrevPageFun() {   //  返回检索
                // this.$router.go(-1);    //  返回上一页面
                this.$router.push({ name: 'archivesRetrieval', params: { searchTabVal: this.$route.params.searchTabVal } });
            }
        }
    }
</script>